"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import Cookies from "js-cookie";

import { LP_VISITED_COOKIE, LP_VISITED_COOKIE_VALUE, OESTRA_LP_PATHS } from "~/constants/oestraLandingPages";

const LpVisitCookie = () => {
    const pathname = usePathname();

    useEffect(() => {
        if (!OESTRA_LP_PATHS.has(pathname)) return;

        Cookies.set(LP_VISITED_COOKIE, LP_VISITED_COOKIE_VALUE, { path: "/", sameSite: "lax" });
    }, [pathname]);

    return null;
};

export default LpVisitCookie;
